import ZoneForm from '@/components/zones/ZoneForm'
import { SharedProps, Zone } from '@/types'
import { Head, router } from '@inertiajs/react'
import { Container, Paper, Stack, Title } from '@mantine/core'

type ZoneFormValues = Pick<Zone, 'name' | 'service_days'>

export default function NewZonePage({ current_organization }: SharedProps) {
  const handleCreateZone = (values: ZoneFormValues) =>
    router.post(`/organizations/${current_organization!.slug}/zones`, { zone: values })

  return (
    <>
      <Head title={`Nouvelle zone - ${current_organization?.name}`} />

      <Container size="sm">
        <Stack gap="xl">
          <Title>Nouvelle zone</Title>

          <Paper withBorder radius="md" p="md">
            <ZoneForm onSubmit={handleCreateZone} submitLabel="Créer la zone" />
          </Paper>
        </Stack>
      </Container>
    </>
  )
}
